module.exports = __webpack_public_path__ + "static/tab22-4fb91d3898f091172b8b9206b1733ea2.jpg";